import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss']
})
export class BrandComponent implements OnInit {
brands = [
    {
      name: 'Unikai',
      category: 'Dairy, Ice Cream, Juice, Foods',
      logo: 'assets/img/brands/brand7.png',
      image: 'assets/img/brands-page/unikai.png',
      bgImage: 'assets/img/mask/mask-1.svg',
      description:
        'Unikai, the flagship brand of Unikai Foods P.J.S.C., has built decades of trust with millions of retailers and consumers. A UAE legacy, it offers dairy, juices, ice cream, and foods in bulk and retail packs, catering to everyday needs with quality and convenience.'
    },
    {
      name: 'Classic Mumtaz',
      category: 'Rice',
      logo: 'assets/img/brands/brand12.png',
      image: 'assets/img/brands-page/mumtaz.png',
      bgImage: 'assets/img/mask/mask-15.svg',
      description:
        'Mumtaz has been delivering trusted, high-quality rice for over four decades. Sourced from regions renowned for their grains, our aromatic rice comes from farm to table, with a variety of premium variants designed to suit every taste and preference.'
    },
    {
      name: 'Soft Scoop',
      category: 'Ice Cream',
      logo: 'assets/img/brands/brand5.png',
      image: 'assets/img/brands-page/softscoop.png',
      bgImage: 'assets/img/mask/mask-16.svg',
      description:
        'Soft Scoop offers deliciously smooth ice cream in convenient tubs, cups, and bulk packs. A favourite for kids and families, it’s an easy win for retail and wholesale customers looking for great taste, strong value, and steady demand.'
    },
    {
      name: 'Delite',
      category: 'Dairy , Foods',
      logo: 'assets/img/brands/brand4.png',
      image: 'assets/img/brands-page/delite.png',
      bgImage: 'assets/img/mask/mask-2.svg',
      description:
        'Delite offers a wide range of globally sourced products, from perfectly baked cupcakes and swiss rolls to cheeses, culinary essentials, ketchup, hot sauce,  spreads and cooking oils. Made for convenience and high quality, Delite ensures delicious meals and snacks anytime.'
    },
    {
      name: 'Laser',
      category: 'Juice',
      logo: 'assets/img/brands/brand3.png',
      image: 'assets/img/brands-page/laser.png',
      bgImage: 'assets/img/mask/mask-3.svg',
      description:
        'Laser Juice brings fun and refreshment to busy days! Made from the finest fruits, it’s perfect for kids and adults on the go—whether at school, a birthday party, or hanging out with friends. Delicious, fruity, and always fun!'
    },
    {
      name: 'Tropical Fresh',
      category: 'Juice',
      logo: 'assets/img/brands/brand13.png',
      image: 'assets/img/brands-page/tropicalfresh.png',
      bgImage: 'assets/img/mask/mask-4.svg',
      description:
        'Tropical Fresh captures the exotic flavors of Thai coconut, celebrated around the world. Bursting with natural taste and refreshment, it brings a tropical experience to every sip, making it the perfect choice for those who love authentic, flavorful coconut drinks'
    },
    {
      name: 'Areej',
      category: 'Juice, Ice Cream, Rice',
      logo: 'assets/img/brands/brand11.png',
      image: 'assets/img/brands-page/areej.png',
      bgImage: 'assets/img/mask/mask-5.svg',
      slug: 'areej',
      description:
        'Areej is a nostalgic and valued brand, cherished by Emiratis and expats alike. Its juices and lollies have become regional favorites, earning credibility and a special place in customers’ hearts. Produced and marketed by Unikai Foods P.J.S.C., Areej continues to delight across the UAE and Gulf region.'
    },
    {
      name: 'Silk',
      category: 'Ice Cream',
      logo: 'assets/img/brands/brand8.png',
      image: 'assets/img/brands-page/silk.png',
      bgImage: 'assets/img/mask/mask-6.svg',
      description:
        'Silk brings affordable, luxurious treats in exciting variants that keep up with the trends and preferences of today’s generations. Staying true to its roots, Silk delivers quality products that delight consumers while offering a modern, indulgent experience'
    },
    {
      name: 'Shahi Kulfi',
      category: 'Ice Cream',
      logo: 'assets/img/brands/brand10.png',
      image: 'assets/img/brands-page/shahikulfi.png',
      bgImage: 'assets/img/mask/mask-7.svg',
      description:
        'Shahi Kulfi offers a rich and pure taste that takes you back in time - a flavor rooted in tradition that makes you feel at home. True to its Eastern Asian origins, Shahi Kulfi delivers authenticity in every bite'
    },
    {
      name: 'Nutty Cone',
      category: 'Ice Cream',
      logo: 'assets/img/brands/brand9.png',
      image: 'assets/img/brands-page/nuttycone.png',
      bgImage: 'assets/img/mask/mask-8.svg',
      description:
        'Nutty Cone brings you delicious waffles filled with ice cream, adding a fun and tasty twist to your everyday treats. Perfect for a sweet indulgence, Nutty Cone offers variety and joy in every bite'
    },
    {
      name: 'Magma',
      category: 'Ice Cream',
      logo: 'assets/img/brands/brand1.png',
      image: 'assets/img/brands-page/magma.png',
      bgImage: 'assets/img/mask/mask-9.svg',
      description:
        'Magma Premium Ice Cream offers a velvety, smooth experience with every bite. Bursting with rich flavors and creamy delight, it’s the perfect treat to elevate dessert moments into indulgent experiences.'
    },
    {
      name: 'U',
      category: 'Foods',
      logo: 'assets/img/brands/brand6.png',
      image: 'assets/img/brands-page/u.png',
      bgImage: 'assets/img/mask/mask-10.svg',
      description:
        'U is a brand born from Unikai, delivering trusted quality and refreshing beverages. With a focus on high quality water and hydration, U brings reliability and refreshment to every sip, reflecting Unikai’s legacy of excellence'
    },
    {
      name: 'Sambharam',
      category: 'Dairy',
      logo: 'assets/img/brands/brand14.png',
      image: 'assets/img/brands-page/sambharam.png',
      bgImage: 'assets/img/mask/mask-11.svg',
      description:
        'Sambharam brings the authentic taste of Kerala’s chilli laban in a ready-to-drink format. Tangy, creamy, and perfectly spiced, it’s a unique dairy refreshment for those who love bold, traditional flavors.'
    },
    {
      name: 'Al Sadah',
      category: 'Rice',
      logo: 'assets/img/brands/brand16.png',
      image: 'assets/img/brands-page/alsadah.png',
      bgImage: 'assets/img/mask/mask-12.svg',
      description:
        'Al Sadah 1121 XXL Basmati Rice is a premium-grade, long-grain rice sourced from the fertile plains of India, renowned for producing the finest basmati varieties. Known for its extra-long grains, aromatic fragrance, and fluffy texture, this rice is the perfect choice for those who value quality and authenticity in their meals. Perfect for traditional dishes like Biryani, Pulao, and Fried Rice.'
    },
    {
      name: 'Al Gubaira',
      category: 'Rice',
      logo: 'assets/img/brands/brand15.png',
      image: 'assets/img/brands-page/algubaira.png',
      bgImage: 'assets/img/mask/mask-13.svg',
      description:
        'Al Gubaira Basmati Rice comes from the fertile Indian plains, known worldwide for cultivating superior basmati. Carefully selected for its long, slender grains, rich aroma, and soft, non-sticky finish, this premium rice delivers an authentic dining experience. It is an excellent choice for preparing traditional favourites like Biryani, Pulao, and Fried Rice.'
    },
    {
      name: 'Areej',
      category: 'Rice',
      logo: 'assets/img/brands/brand11.png',
      image: 'assets/img/brands-page/areejrice.png',
      bgImage: 'assets/img/mask/mask-14.svg',
      slug: 'areej',
      description:
        'Areej Biryani Rice is crafted from the finest PR11 White Rice, sourced from India’s renowned rice-growing regions. This variety is celebrated for its medium-long grains, soft texture,  and subtle aroma, making it an excellent choice for authentic biryanis and everyday meals. Why Choose Areej Biryani Rice? Ideal for traditional biryanis, pulao, and family meals. Affordable yet premium quality for consistent taste. A trusted brand for chefs and  home cooks alike.'
    }
  ];


  constructor() { }

  ngOnInit(): void {
  }

}